"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Hiring-use variant per the legal-approved "Sara Consent Updates" memo:
 * defined 4-year retention replaces indefinite retention, downstream
 * consequences disclosed (skill badges drive matching and access to
 * higher-paying work), human review tied to override authority, ElevenLabs
 * named as vendor/processor (Illinois disclosure), Illinois added to the
 * rights section, and the live-call alternative framed as an
 * accommodation pathway with equivalent badging outcomes.
 */
const v4 = {
    label: 'I consent to this conversation being **recorded** and **analyzed by AI** ' +
        'to help evaluate my responses. This evaluation informs skill badges that ' +
        'affect which shifts I am matched to, including access to higher-skill ' +
        'and higher-paying work. A human with authority to change the outcome ' +
        "reviews the transcript and the AI's assessment. My recording and " +
        'transcript are kept for 4 years and then deleted, and I can request ' +
        'deletion sooner.',
    lastUpdated: '2026-07-23',
    modalSections: [
        {
            heading: "What's recorded",
            body: 'Your audio, a transcript of your responses, and basic session ' +
                'data (e.g., timestamps). We do not create a voiceprint or any ' +
                'other biometric identifier from your audio, and we do not use ' +
                'your voice to identify you.',
        },
        {
            heading: 'What the AI does',
            body: 'Analyzes the content of your responses to evaluate them against ' +
                'the skill criteria for this role. Based on that evaluation you may ' +
                'be assigned skill badges. These badges affect your matching ' +
                'priority on the platform, including your access to higher-skill ' +
                'and higher-paying shifts. The AI interviewer ("Sara") is provided ' +
                'using voice-AI technology from our service provider, Eleven Labs, Inc.',
        },
        {
            heading: "What the AI doesn't do",
            body: 'It does not evaluate your appearance, accent, or any protected ' +
                'characteristic. A human with authority to change the outcome ' +
                "reviews the transcript and the AI's assessment.",
        },
        {
            heading: 'Your data',
            body: '- Stored encrypted; access limited to the team that invited you ' +
                'and our service provider (ElevenLabs), who processes the audio on ' +
                'our behalf.\n' +
                '- Your audio recording, transcript, and assessment are retained ' +
                'for 4 years and then permanently deleted.\n' +
                '- You may request deletion sooner at any time, subject to any ' +
                'legal record-keeping obligations.\n' +
                '- Not sold. Not used to train AI models.',
        },
        {
            heading: 'Your rights',
            body: '- **Request an alternative** to the AI format. You may decline the ' +
                'AI interview and instead complete an equivalent evaluation by live ' +
                'call with a person — including as a disability accommodation or ' +
                'for any other reason. Choosing this option will not disadvantage ' +
                'you and leads to the same badging outcomes.\n' +
                '- **Access or delete** your recording, transcript, and assessment ' +
                'at any time.\n' +
                '- **Request human review** by a person with authority to change ' +
                'the outcome if you believe a decision was unfair.\n' +
                '- Residents of certain states (including California and Illinois) ' +
                'and other jurisdictions may have additional rights under ' +
                'applicable privacy laws.',
        },
        {
            heading: 'Questions or concerns',
            body: 'Contact the team at the email provided in your invitation.',
        },
    ],
};
exports.default = v4;
